import { observer } from 'mobx-react-lite'

export const Divider = observer(() => {
    return <div className="my-3" />
})
